"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectComponentObserver = void 0;
const Select_1 = require("./Select");
class SelectComponentObserver {
    constructor() {
        this.selectComponentElementAttribute = 'data-js-select-component'; //Add to main div of component
        const container = document.documentElement || document.body;
        [...container.querySelectorAll(`[${this.selectComponentElementAttribute}]`)].forEach((element) => {
            new Select_1.Select(element);
        });
    }
    observe() {
        const container = document.documentElement || document.body;
        const observerOptions = {
            childList: true,
            subtree: true
        };
        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (mutation.type === "childList") {
                    mutation.addedNodes.forEach((node) => {
                        if (node instanceof HTMLElement && node.hasAttribute(`[${this.selectComponentElementAttribute}]`)) {
                            new Select_1.Select(node);
                        }
                    });
                }
            });
        });
        observer.observe(container, observerOptions);
    }
}
exports.SelectComponentObserver = SelectComponentObserver;
